import RoutePath from '../../../../../constants/routePath';

export class GeneralRouterHelper {
  
  static MY_PROFILE_PATH = RoutePath.ROUTE_MY_PROFILE;
  
  // TODO: add proper 404 redirect and remove this
  static NOT_FOUND_PATH = 'not-found';
  
}
